import { service } from '@/ajax/request'


export const suggestionList = (params: any) => (
  service({
    url: '/device/tongue/suggestionList',
    method: 'GET',
    params,
    type: 'form'
  })
)


export const update = (params: any) => (
  service({
    url: '/device/tongue/update',
    method: 'POST',
    params,
    type: 'form'
  })
)


export const storeDiagnoses = (params: any) => (
  service({
    url: '/store/storeDiagnoses/list',
    method: 'POST',
    params,
    type: 'form'
  })
)


export const save = (params: any) => (
  service({
    url: '/store/storeDiagnoses/save',
    method: 'POST',
    params
  })
)

export const getDiagnosesTypeList = (params: any) => (
  service({
    url: '/store/storeDiagnoses/getDiagnosesTypeList',
    method: 'GET',
    params,
    type: 'form'
  })
)

export const getAllDiagnosesData = (params: any) => (
  service({
    url: '/store/storeDiagnoses/getAllDiagnosesData',
    method: 'GET',
    params,
    type: 'form'
  })
)


export const tongueProfileList = (params: any) => {
  return service({
    url: '/tongue-profile/list',
    method: 'POST',
    params
  })
}
export const tongueProfileEdit = (params: any) => {
  return service({
    url: '/tongue-profile/edit',
    method: 'POST',
    params
  })
}
export const tongueExplainList = (params: any) => {
  return service({
    url: '/tongue-explain/list',
    method: 'POST',
    params
  })
}
export const tongueExplainTypeList = (parentId: number | string) => {
  return service({
    url: `/tongue-explain/get-tongue-type-list/${parentId}`,
    method: 'POST',
  })
}
export const tongueExplainEdit = (params: any) => {
  return service({
    url: `/tongue-explain/save-or-update`,
    method: 'POST',
    params,
  })
}
export const tongueExplainDel = (id: number) => {
  return service({
    url: `/tongue-explain/delete/${id}`,
    method: 'POST',
  })
}
export const tongueShareConfig = (params: any) => {
  return service({
    url: `/tongue-share-config/get-page`,
    method: 'POST',
    params
  })
}

export const disableDiagnoses = (id) => {
  return service({
    url: `/store/storeDiagnoses/disable-diagnoses`,
    method: 'POST',
    params: { id },
  })
}

export const getPhysiqueNameList = (params) => {
  return service({
    url: `/tongue-share-config/get-physique-kv`,
    method: 'POST',
    params
  })
}

export const tongueSubSymptom = (params) => {
  return service({
    url: `/tongue-ex-symptom/save-or-update`,
    method: 'POST',
    params
  })
}

export const tongueSubSymptomList = (params) => {
  return service({
    url: `/tongue-ex-symptom/get-page`,
    method: 'POST',
    params
  })
}

export const tongueSubSymptomAllList = (params) => {
  return service({
    url: `/tongue-ex-symptom/get-List`,
    method: 'POST',
    params
  })
}

export const tongueSubSymptomConfigList = (params) => {
  return service({
    url: `/tongue-ex-config/get-page`,
    method: 'POST',
    params
  })
}

export const tongueSubSymptomConfigSave = (params) => {
  return service({
    url: `/tongue-ex-config/save-or-update`,
    method: 'POST',
    params
  })
}

export const getTongueApiOverview = (params) => {
  return service({
    url: `/tongue-api-overview/get-page`,
    method: 'POST',
    params
  })
}

export const getStoreSmartDevices = (storeId: number | string) => {
  return service({
    url: `/device/deviceManage/getStoreSmartDevices/${storeId}`,
    method: 'POST',
    type: 'form'
  })
}

export const listSleepMonitorDevices = (params: { storeId: number | string }) => {
  return service({
    url: '/store/storeDiagnoses/listSleepMonitorDevices',
    method: 'POST',
    params,
  })
}

/**
 * 根据品牌方ID获取舌诊综合建议配置列表（不分页）
 */
export const getTongueComprehensiveSuggestionList = (merchantId: number | string) => {
  return service({
    url: `/tongue-comprehensive-suggestion/list-by-merchant/${merchantId}`,
    method: 'POST',
  })
}

/**
 * 保存舌诊综合建议配置（批量接口，单条修改时传一条数据）
 */
export const saveTongueComprehensiveSuggestionBatch = (params: { items: Array<{ id: number, comprehensiveSuggestion: string }> }) => {
  return service({
    url: '/tongue-comprehensive-suggestion/save-batch',
    method: 'POST',
    params,
  })
}